export default __webpack_public_path__ + "static/media/East Cleave of the Azure Dragon.9a9f69da.jpg";